import * as React from "react";
import { useState } from "react";
import { URLS, useAccountSettings } from "@/utils";
import { Category } from "@/services/bedrock";
import { PaginationSimple } from "@/components/ui";
import { WebComponents } from "@/interfaces";
import { useHistory } from "react-router-dom";
import { SuperPageCard } from ".";
import { cn } from "@/lib/utils";
import { useSuperPageSearch } from "@/utils/useSuperPageSearch";

type Props = {
  category: Category | null;
  searchTerm?: string;
  selectedStatus?: string | null | undefined;
};

const SuperPagesCategoryList: React.FC<Props> = ({ category, searchTerm, selectedStatus }) => {
  const [page, setPage] = useState(1);
  const { hasWritePermission } = useAccountSettings();
  const withWritePermission = hasWritePermission(WebComponents.VIDEO_PAGES);
  const history = useHistory();
  const { searchSuperPages } = useSuperPageSearch();

  const { superPages, isFetching } = searchSuperPages({
    categoryId: category?.id,
    search: searchTerm,
    uncategorized: category == null ? true : undefined,
    extraFields: ["totalViews", "totalClicks", "assignmentsOverview", "categories"],
    status: selectedStatus,
    page,
    perPage: 4,
    sort: "title",
    order: "asc",
  });

  const content = superPages?.content ?? [];
  const totalPages = superPages?.pagination?.totalPages ?? 0;

  const goToNewSuperPage = () => {
    history.push(URLS.coach.newSuperPage);
  };

  const actions = [];
  if (withWritePermission) {
    actions.push({ text: "New Super Page", onClick: goToNewSuperPage });
  }
  if (content.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4 h-initial">
      <div className="flex items-center gap-2 justify-between">
        <h2
          className={cn(
            "text-start text-xl font-bold ignore-base-styling flex-grow m-0 p-0",
            !category ? "text-gray-500 italic" : "text-foreground"
          )}
        >
          {category?.name ?? "Uncategorized"}
        </h2>
        {totalPages > 1 && (
          <PaginationSimple page={page} totalPages={totalPages} onPageChange={setPage} disabled={isFetching} />
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {content.map(superPage => (
          <SuperPageCard key={`super-page-${superPage.id}`} superPage={superPage} disabled={isFetching} />
        ))}
      </div>
    </div>
  );
};

export { SuperPagesCategoryList };
